import IccConfigForm from "./IccConfigForm";
import { CREATE_ICC_CONFIG } from "./query";
import { Link } from "react-router-dom";

const CreateIccConfig = () => {
    return (
        <div className="custom-shadow p-5">
            <Link to="/global-config/abbvie-id/icc-config" className="btn btn-outline-primary mb-5">
                Back
            </Link>
            <h3 className="mb-5">Create ICC Config</h3>
            <IccConfigForm query={CREATE_ICC_CONFIG} />
        </div>
    );
};

export default CreateIccConfig;
